import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: resolve => require(['@/views/home'], resolve),
      redirect: {
        path: 'index'
      },
      children: [{
          path: 'index',
          name: 'index',
          component: resolve => require(['@/views/index/index'], resolve),
          meta: {
            keepLive: false, //判断是否需要缓存
            isBack: false
          },
        },

        {
          path: 'privacy',
          name: 'privacy',
          component: resolve => require(['@/views/index/privacy'], resolve),
          meta: {

          },
        },
        {
          path: 'useAgreement',
          name: 'useAgreement',
          component: resolve => require(['@/views/index/useAgreement'], resolve),
          meta: {

          },
        },
        {
          path: 'collegeClass',
          name: 'collegeClass',
          component: resolve => require(['@/views/collegeClass/collegeClass'], resolve),
          meta: {

          },
        },
        {
          path: 'search',
          name: 'search',
          component: resolve => require(['@/views/index/search'], resolve),
          meta: {

          },
        },
        {
          path: 'searchCollege',
          name: 'searchCollege',
          component: resolve => require(['@/views/index/searchCollege'], resolve),
          meta: {

          },
        },
        {
          path: 'searchCertificate',
          name: 'searchCertificate',
          component: resolve => require(['@/views/index/searchCertificate'], resolve),
          meta: {

          },
        },
        {
          path: 'searchCourse',
          name: 'searchCourse',
          component: resolve => require(['@/views/index/searchCourse'], resolve),
          meta: {

          },
        },
        {
          path: 'searchTeacher',
          name: 'searchTeacher',
          component: resolve => require(['@/views/index/searchTeacher'], resolve),
          meta: {

          },
        },
        {
          path: 'collegeClass/college/:id',
          name: 'college',
          component: resolve => require(['@/views/collegeClass/college'], resolve),
          meta: {

          },
        },
        {
          path: 'collegeClass/class',
          name: 'class',
          component: resolve => require(['@/views/collegeClass/class'], resolve),
          meta: {

          },
        }, {
          path: 'curriculum',
          name: 'curriculum',
          component: resolve => require(['@/views/curriculum/curriculum'], resolve),
          meta: {
            keepLive: true, //判断是否需要缓存
            isBack: false,
            CurrKeepAlive: false
          },
        }, {
          path: 'recourse',
          name: 'recourse',
          component: resolve => require(['@/views/curriculum/recourse'], resolve),
          meta: {
            keepLive: false, //判断是否需要缓存
            isBack: false
          },
        },
        {
          path: 'playvideo',
          name: 'playvideo',
          component: resolve => require(['@/views/curriculum/playvideo'], resolve),
          meta: {

          },
        },
        {
          path: 'liveplay',
          name: 'liveplay',
          component: resolve => require(['@/views/courseLive/liveplay'], resolve),
          meta: {

          },
        },
        {
          path: 'faculty',
          name: 'faculty',
          component: resolve => require(['@/views/faculty/faculty'], resolve),
          meta: {
            keepLive: true, //判断是否需要缓存
            isBack: false,
            FacKeepAlive: false
          },
        },
        {
          path: 'detailinfo',
          name: 'detailinfo',
          component: resolve => require(['@/views/faculty/detailinfo'], resolve),
          meta: {
            keepLive: false, //判断是否需要缓存
            isBack: false
          },
        },
        {
          path: 'collmange',
          name: 'collmange',
          component: resolve => require(['@/views/collmange/collmange'], resolve),
          meta: {

          },
        },
        {
          path: 'settings',
          name: 'settings',
          component: resolve => require(['@/views/user/settings'], resolve),
          meta: {
            role: true
          },

        },
        {
          path: '/order/orderMain',
          name: 'orderMain',
          component: resolve => require(['@/views/user/orderMain'], resolve),
          meta: {
            role: true
          },
        },
        {
          path: 'order',
          name: 'order',
          component: resolve => require(['@/views/user/order'], resolve),
          meta: {
            role: true
          },
        },
        {
          path: 'invoice',
          name: 'invoice',
          component: resolve => require(['@/views/user/invoice'], resolve),
          meta: {
            role: true
          },
        }, {
          path: 'playvideo',
          name: 'playvideo',
          component: resolve => require(['@/views/curriculum/playvideo'], resolve),
          meta: {

          },
        },
        {
          path: 'faculty',
          name: 'faculty',
          component: resolve => require(['@/views/faculty/faculty'], resolve),
          meta: {

          },
        },
        {
          path: 'detailinfo',
          name: 'detailinfo',
          component: resolve => require(['@/views/faculty/detailinfo'], resolve),
          meta: {

          },
        },
        {
          path: 'personal',
          name: 'personal',
          component: resolve => require(['@/views/personal/personal'], resolve),
          meta: {

          },
          redirect: {
            path: '/personal/selfCourse'
          },
          children: [{
              path: '/personal/selfCourse',
              name: 'selfCourse',
              component: resolve => require(['@/views/personal/selfCourse'], resolve),
            },
            {
              path: '/personal/selfExam',
              name: 'selfExam',
              component: resolve => require(['@/views/personal/selfExam'], resolve),
            },
            {
              path: '/personal/selfClass',
              name: 'selfClass',
              component: resolve => require(['@/views/personal/selfClass'], resolve),
            },
            {
              path: '/personal/selfFact',
              name: 'selfFact',
              component: resolve => require(['@/views/personal/selfFact'], resolve),
            },
            {
              path: '/personal/studyHistory',
              name: 'studyHistory',
              component: resolve => require(['@/views/personal/studyHistory'], resolve),
            }
          ]
        },
        {
          path: 'examMain',
          name: 'examMain',
          component: resolve => require(['@/views/personal/examMain'], resolve),
        },
        {
          path: 'msgMain',
          name: 'msgMain',
          component: resolve => require(['@/views/personal/msgMain'], resolve),
        },
        {
          path: 'playervideo',
          name: 'playervideo',
          component: resolve => require(['@/views/personal/playervideo'], resolve),
          meta: {

          },
        },
        {
          path: 'playCertVideo',
          name: 'playCertVideo',
          component: resolve => require(['@/views/personal/playVideo'], resolve),
          meta: {

          },
        },
        {
          path: 'liveCenterPlay',
          name: 'liveCenterPlay',
          component: resolve => require(['@/views/personal/liveCenterPlay'], resolve),
          meta: {

          },
        },
        {
          path: 'shopcar',
          name: 'shopcar',
          component: resolve => require(['@/views/shopcar/shopcar'], resolve),
          meta: {
            role: true
          },
        },
        {
          path: 'orderList',
          name: 'orderList',
          component: resolve => require(['@/views/shopcar/orderList'], resolve),
          meta: {

          },
        },
        {
          path: 'classOrder',
          name: 'classOrder',
          component: resolve => require(['@/views/shopcar/classOrder'], resolve),
          meta: {

          },
        },
        {
          path: 'payList',
          name: 'payList',
          component: resolve => require(['@/views/shopcar/payList'], resolve),
          meta: {

          },
        },
        {
          path: 'orderfornow',
          name: 'orderfornow',
          component: resolve => require(['@/views/shopcar/orderfornow'], resolve),
          meta: {},
        },
        {
          path: 'wxpay',
          name: 'wxpay',
          component: resolve => require(['@/views/shopcar/wxpay'], resolve),
          meta: {

          },
        },
        {
          path: 'succ',
          name: 'succ',
          component: resolve => require(['@/views/shopcar/succ'], resolve),
          meta: {

          },
        },
        {
          path: 'success',
          name: 'success',
          component: resolve => require(['@/views/shopcar/success'], resolve),
          meta: {

          },
        },
        {
          path: 'fail',
          name: 'fail',
          component: resolve => require(['@/views/shopcar/fail'], resolve),
          meta: {

          },
        },
        {
          path: 'Gs_buildCompany',
          name: 'Gs_buildCompany',
          component: resolve => require(['@/views/collmange/Gs_buildCompany'], resolve),
          meta: {

          },
        },
        {
          path: 'Gr_buildCompany',
          name: 'Gr_buildCompany',
          component: resolve => require(['@/views/collmange/Gr_buildCompany'], resolve),
          meta: {

          },
        },
        {
          path: 'certificateStore',
          name: 'CertificateStore',
          component: resolve => require(['@/views/certificate/certificateStore'], resolve),
          meta: {
            keepLive: true, //判断是否需要缓存
            isBack: false,
            PageKeepAlive: false
          },
        },
        {
          path: 'certificateDetail',
          name: 'certificateDetail',
          component: resolve => require(['@/views/certificate/certificateInfo'], resolve),
          meta: {
            keepLive: false, //判断是否需要缓存
            isBack: false
          },
        },
        {
          path: 'certificateOrder',
          name: 'certificateOrder',
          component: resolve => require(['@/views/shopcar/certificateOrder'], resolve),
          meta: {
          },
        },
        {
          path: 'randomTestCenter',
          name: 'randomTestCenter',
          component: resolve => require(['@/views/personal/testCenter/randomGetTest'], resolve),
          meta: {
          },
        },
        {
          path: 'testStart',
          name: 'testStart',
          component: resolve => require(['@/views/personal/testCenter/testStart'], resolve),
          meta: {
          },
        },
        {
          path: 'testSuccess',
          name: 'testSuccess',
          component: resolve => require(['@/views/personal/testCenter/testSuccess'], resolve),
          meta: {
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/login'], resolve),
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/views/login/register'], resolve),
    },
    {
      path: '/findPassword',
      name: 'findPassword',
      component: resolve => require(['@/views/login/findPassword'], resolve),
    },
    {
      path: '/bankLivePlay',
      name: 'bankLivePlay',
      component: resolve => require(['@/views/live/livePlay'], resolve),
    },
    {
      path: '/leader',
      name: 'leader',
      component: resolve => require(['@/views/leader'], resolve),
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js